import { buildPageName } from '../utils/buildPageName'
import type { PresetDefinition } from '@wix/wix-data-client-common'
import { PAGE_TYPES } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

type Params = {
  editorSdkProxy: EditorSDK
  preset: PresetDefinition
  collectionName: string
}

export const addPageWithRepeater = async ({
  editorSdkProxy,
  preset,
  collectionName,
}: Params) => {
  const pageDefinition = preset.pages.find(page => page.type === 'indexPage')

  const pageName = buildPageName({
    collectionName,
    pageType: PAGE_TYPES.COLLECTION,
  })

  const pageRef = await editorSdkProxy.document.pages.add({
    title: pageName,
    definition: pageDefinition!.definition,
    shouldAddMenuItem: true,
    shouldNavigateToPage: false,
  })

  return { pageRef }
}
